import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fullscreen_to",
  "use": "fullscreen_to-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"fullscreen_to\"><path d=\"M5.333 6.613h5.333v-2.56H4.053c-.747 0-1.387.533-1.387 1.28v6.613h2.667V6.613zm21.334 0v5.333h2.667V5.333c0-.747-.64-1.28-1.28-1.28h-6.72V6.72h5.333zm0 18.774h-5.333v2.667h6.613c.747 0 1.28-.64 1.28-1.28v-6.613h-2.56v5.227zm-21.334 0v-5.333H2.666v6.613c0 .747.64 1.28 1.28 1.28h6.72V25.28H5.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol